import { Typography, TypographyProps } from "@mui/material";
import { useStyle } from "./style";
import { PaletteColor } from "@mui/material/styles";

export interface IParams {
    label: string;
    color?: TypographyProps["color"];
    backgroundColor?: PaletteColor["main"];
    isCompactLayout?: boolean;
}

export const CardTag = (props: IParams) => {
    const { label, color, backgroundColor, isCompactLayout } = props;
    const { classes } = useStyle({ backgroundColor, isCompactLayout });

    return (
        <div className={classes.container}>
            <Typography className={classes.text} color={color ?? "primary.contrastText"} variant="large">
                {label}
            </Typography>
        </div>
    );
};
